module.exports = __webpack_public_path__ + "static/billy-almon-a2d81606c6e7321ae8b96150fd914ee3.jpg";